<template>
    <div class="calendar-date-picker">
        <!-- desktop: single month with navigation -->
        <div class="calendar__desktop-date-picker" v-if="availableMonths.length > 0">
            <div class="calendar-date-picker__header">
                <div class="calendar-date-picker__actions">
                    <button
                        @click="previousMonth"
                        :disabled="currentMonthIndex === 0"
                        class="calendar-date-picker__nav-button btn"
                        aria-label="Previous month"
                    />
                    <button
                        @click="nextMonth"
                        :disabled="currentMonthIndex === availableMonths.length - 1"
                        class="calendar-date-picker__nav-button btn"
                        aria-label="Next month"
                    />
                </div>
            </div>
            <CalendarMonth
                :month="availableMonths[currentMonthIndex]"
                :events-by-date="eventsByDate"
                @select-date="selectDate"
            />
        </div>

        <!-- mobile: scrollable month list -->
        <div class="calendar__mobile-date-picker">
            <button @click="datePickerDialogRef?.open()" class="calendar__date-picker-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                    <g clip-path="url(#clip0_858_7833)">
                        <path d="M22.5969 11.3113C22.5969 17.5396 17.5224 22.6142 11.2941 22.6142C5.07455 22.6142 0 17.5396 0 11.3113C0 5.09178 5.07455 0.0172272 11.2941 0.0172272C17.5224 0.0172272 22.5969 5.09178 22.5969 11.3113ZM7.08702 5.74236C5.85525 5.74236 5.23069 6.35824 5.23069 7.57269V15.0587C5.23069 16.2731 5.85525 16.889 7.08702 16.889H15.5099C16.733 16.889 17.3575 16.2731 17.3575 15.0587V7.57269C17.3575 6.35824 16.733 5.74236 15.5099 5.74236H7.08702ZM16.4034 9.42901V15.0934C16.4034 15.6746 16.1258 15.9435 15.5533 15.9435H7.03497C6.47113 15.9435 6.19355 15.6746 6.19355 15.0934V9.42901C6.19355 8.81307 6.5145 8.49219 7.11304 8.49219H15.4665C16.065 8.49219 16.4034 8.81307 16.4034 9.42901ZM8.0065 13.7662C7.76364 13.7662 7.68554 13.8269 7.68554 14.0611V14.4948C7.68554 14.7378 7.76364 14.8071 8.0065 14.8071H8.42288C8.67448 14.8071 8.74383 14.7378 8.74383 14.4948V14.0611C8.74383 13.8269 8.67448 13.7662 8.42288 13.7662H8.0065ZM10.0624 13.7662C9.81079 13.7662 9.75009 13.8269 9.75009 14.0611V14.4948C9.75009 14.7378 9.81079 14.8071 10.0624 14.8071H10.4787C10.7303 14.8071 10.791 14.7378 10.791 14.4948V14.0611C10.791 13.8269 10.7303 13.7662 10.4787 13.7662H10.0624ZM12.1182 13.7662C11.8666 13.7662 11.7972 13.8269 11.7972 14.0611V14.4948C11.7972 14.7378 11.8666 14.8071 12.1182 14.8071H12.5346C12.7774 14.8071 12.8469 14.7378 12.8469 14.4948V14.0611C12.8469 13.8269 12.7774 13.7662 12.5346 13.7662H12.1182ZM8.0065 11.7451C7.76364 11.7451 7.68554 11.8058 7.68554 12.0574V12.4824C7.68554 12.7253 7.76364 12.7773 8.0065 12.7773H8.42288C8.67448 12.7773 8.74383 12.7253 8.74383 12.4824V12.0574C8.74383 11.8058 8.67448 11.7451 8.42288 11.7451H8.0065ZM10.0624 11.7451C9.81079 11.7451 9.75009 11.8058 9.75009 12.0574V12.4824C9.75009 12.7253 9.81079 12.7773 10.0624 12.7773H10.4787C10.7303 12.7773 10.791 12.7253 10.791 12.4824V12.0574C10.791 11.8058 10.7303 11.7451 10.4787 11.7451H10.0624ZM12.1182 11.7451C11.8666 11.7451 11.7972 11.8058 11.7972 12.0574V12.4824C11.7972 12.7253 11.8666 12.7773 12.1182 12.7773H12.5346C12.7774 12.7773 12.8469 12.7253 12.8469 12.4824V12.0574C12.8469 11.8058 12.7774 11.7451 12.5346 11.7451H12.1182ZM14.1653 11.7451C13.9138 11.7451 13.8444 11.8058 13.8444 12.0574V12.4824C13.8444 12.7253 13.9138 12.7773 14.1653 12.7773H14.5817C14.8333 12.7773 14.9113 12.7253 14.9113 12.4824V12.0574C14.9113 11.8058 14.8333 11.7451 14.5817 11.7451H14.1653ZM10.0624 9.71525C9.81079 9.71525 9.75009 9.79334 9.75009 10.0275V10.4699C9.75009 10.6954 9.81079 10.7649 10.0624 10.7649H10.4787C10.7303 10.7649 10.791 10.6954 10.791 10.4699V10.0275C10.791 9.79334 10.7303 9.71525 10.4787 9.71525H10.0624ZM12.1182 9.71525C11.8666 9.71525 11.7972 9.79334 11.7972 10.0275V10.4699C11.7972 10.6954 11.8666 10.7649 12.1182 10.7649H12.5346C12.7774 10.7649 12.8469 10.6954 12.8469 10.4699V10.0275C12.8469 9.79334 12.7774 9.71525 12.5346 9.71525H12.1182ZM14.1653 9.71525C13.9138 9.71525 13.8444 9.79334 13.8444 10.0275V10.4699C13.8444 10.6954 13.9138 10.7649 14.1653 10.7649H14.5817C14.8333 10.7649 14.9113 10.6954 14.9113 10.4699V10.0275C14.9113 9.79334 14.8333 9.71525 14.5817 9.71525H14.1653Z" fill="black"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_858_7833">
                            <rect width="22.8571" height="22.6143" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
                Jump to date
            </button>
            <Dialog ref="datePickerDialogRef" @close="handleDatePickerClose">
                <CalendarMonth
                    v-for="month in availableMonths"
                    :key="month.toISOString()"
                    :month="month"
                    :events-by-date="eventsByDate"
                    @select-date="selectDate"
                />
            </Dialog>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import {startOfMonth} from "date-fns";
import {formatDayKey, formatMonthKey} from '../utils/date-formatters.mjs';
import { useState } from '../services/stateful';
import CalendarMonth from './CalendarMonth.vue';
import Dialog from '../Dialog/Dialog.vue';
import {getFirstEventOfMonth} from "../utils/event.mjs";

const props = defineProps({
    events: {
        type: Array,
        required: true,
    },
});

const featureEnabled = window.featureEnabled; //Required for access in template

const datePickerDialogRef = ref(null);
const currentMonthIndex = ref(0);

const activeMonth = useState('CalendarList.ActiveMonth', new Date());
const selectedDate = useState('Calendar.SelectedDate', null);
const scrollToDayKey = useState('CalendarList.ScrollToDayKey', null);

const availableMonths = computed(() => {
    const months = new Map();

    props.events.forEach(event => {
        const date = event.performancedate;
        if (isNaN(date.getTime())) {
            console.warn(`Invalid date in event: ${date}`);
            return;
        }
        const monthKey = formatMonthKey(date);
        const monthDate = new Date(date.getFullYear(), date.getMonth(), 1);

        if (!months.has(monthKey)) {
            months.set(monthKey, monthDate);
        }
    });

    return Array.from(months.values()).sort((a, b) => a - b);
});

const eventsByDate = computed(() => {
    const map = {};
    props.events.forEach(event => {
        const dateKey = formatDayKey(event.startDate);
        if (!map[dateKey]) {
            map[dateKey] = [];
        }
        map[dateKey].push(event);
    });
    return map;
});

const selectDate = (day) => {
    if (featureEnabled('calendar.paginated')) {
        activeMonth.value = day;
    }

    selectedDate.value = day;
};

const handleDatePickerClose = () => {
    // Dialog closed
};

const previousMonth = () => {
    if (currentMonthIndex.value > 0) {
        currentMonthIndex.value--;
        const month = availableMonths.value[currentMonthIndex.value];
        activeMonth.value = month;

        if (featureEnabled('calendar.paginated')) {
            const earliestEventDate = getFirstEventOfMonth(month, props.events);
            scrollToDayKey.value = formatDayKey(earliestEventDate);
        }
    }
};

const nextMonth = () => {
    if (currentMonthIndex.value < availableMonths.value.length - 1) {
        currentMonthIndex.value++;
        const month = availableMonths.value[currentMonthIndex.value];
        activeMonth.value = month;

        if (featureEnabled('calendar.paginated')) {
            const earliestEventDate = getFirstEventOfMonth(month, props.events);
            scrollToDayKey.value = formatDayKey(earliestEventDate);
        }
    }
}

watch(availableMonths, () => {
    const targetMonth = startOfMonth(activeMonth.value);
    recalculateCurrentMonthIndex(targetMonth);
});

watch(() => activeMonth.value, (newActiveMonth) => {
    const targetMonth = startOfMonth(newActiveMonth);
    recalculateCurrentMonthIndex(targetMonth);
});

const recalculateCurrentMonthIndex = (targetMonth) => {
    const index = availableMonths.value.findIndex(month => {
        return month.getMonth() === targetMonth.getMonth() && month.getFullYear() === targetMonth.getFullYear();
    });

    if (index !== -1 && index !== currentMonthIndex.value) {
        currentMonthIndex.value = index;
    }
}

defineExpose({
    open: () => datePickerDialogRef.value?.open(),
});
</script>
